var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 10a1 1 0 00.993-.883L6 9V3.675l1.85 1.584a1 1 0 001.391-1.43l-.09-.088L5 .183.85 3.74a1 1 0 001.2 1.594l.1-.076L4 3.675V9a1 1 0 001 1z",
    fill: "#000",
    fillRule: "nonzero"
  })));
}
export default __webpack_public_path__ + "img/8d00b2dae42c898022e448cfd716cfcc.svg";
export { SvgArrowIcon as ReactComponent };